// Maßstab, mit dem eine PDF-Seite bei Zoom 1 ("eingepasst") gezeichnet wird:
// die ganze Seite sichtbar, also Breite UND Höhe der Fläche einhalten.
// Bis v3.0.8 zählte nur die Breite, eine A4-Seite war am Bildschirm im
// Querformat dann gut doppelt so hoch wie die Fläche.
// seite: Viewport bei Maßstab 1 ({ width, height }), breite/hoehe: freie Fläche in px.
export const PDF_RUECKFALL_BREITE = 800;

export function einpassMassstab(seite, breite, hoehe) {
  if (!seite || !(seite.width > 0) || !(seite.height > 0)) return 1;
  const nachBreite = breite > 0 ? breite / seite.width : null;
  const nachHoehe = hoehe > 0 ? hoehe / seite.height : null;
  if (nachBreite && nachHoehe) return Math.min(nachBreite, nachHoehe);
  return nachBreite || nachHoehe || PDF_RUECKFALL_BREITE / seite.width;
}
